import { TOptions } from '../types/types';
import { hasPermission } from './HelperFunctions';

export const serviceProviderSelectProps = (language: string, beforeOptionsMaping?: (options: any) => any) => ({
  labelKey: `name.${language}`,
  valueKey: 'id',
  searchKeys: ['first_name', 'last_name', 'email', 'mobile'],
  modelRoute: '/service-providers?per_page=1000',
  beforeOptionsMaping,
  queryKey: ['service-providers'],
  enabled: hasPermission(['service_providers.show'])
});

export const makesSelectProps = (staticOptions?: TOptions[]) => ({
  labelKey: ['name'],
  valueKey: 'id',
  modelRoute: 'admin/makes',
  queryKey: ['vehicle-makes'],
  staticOptions,
  enabled: hasPermission(['makes.show'])
});

export const workSectorsSelectProps = (language: string) => ({
  labelKey: [`name[${language}]`],
  valueKey: 'id',
  modelRoute: `/work-sectors`,
  queryKey: ['work-sectors'],
  enabled: hasPermission(['work_sectors.show'])
});

export const nationalitiesSelectProps = (language: string) => ({
  labelKey: [`name[${language}]`],
  valueKey: 'id',
  modelRoute: `/admin/nationalities`,
  queryKey: ['nationalities']
});

export const modelsSelectProps = (makeId?: number | string, staticOptions?: TOptions[]) => ({
  labelKey: [`name.en`],
  valueKey: 'id',
  modelRoute: `admin/makes/${makeId}/models`,
  queryKey: ['models', makeId],
  enabled: !!makeId && hasPermission(['models.show']),
  staticOptions
});

export const variantsSelectProps = (modelId?: number | string, staticOptions?: TOptions[], language?: string) => ({
  labelKey: [`display_name_translation[${language}]`],
  valueKey: 'id',
  modelRoute: `admin/models/${modelId}/variants`,
  queryKey: ['variants', modelId],
  enabled: !!modelId && modelId !== 'all' && hasPermission(['variants.show']),
  staticOptions
});

export const chassisSelectProps = (variantId?: number | string, exteriorColorId?: number, interiorColorId?: number, valueKey?: 'chassis' | 'id') => ({
  labelKey: 'chassis',
  valueKey: valueKey || 'id',
  modelRoute: `admin/vehicles/filter?variant_id=${variantId}&exterior_color_id=${exteriorColorId}&interior_color_id=${interiorColorId}&in_stock=1`,
  queryKey: ['vehicles', variantId, exteriorColorId, interiorColorId],
  enabled: !!variantId && variantId !== 'all' && !!exteriorColorId && !!interiorColorId && hasPermission(['vehicles.show'])
});

export const salesSelectProps = (disabled?: boolean, beforeOptionsMaping?: (options: any) => any) => ({
  labelKey: ['first_name', 'last_name'],
  valueKey: 'id',
  withoutDashes: true,
  beforeOptionsMaping,
  modelRoute: 'admin/admins?relations=roles,roles.permissions&per_page=1000',
  queryKey: ['admins', "select", "sales"],
  enabled: hasPermission(['admins.show']) && !disabled
});